module.exports = require("@mui/icons-material/FormatBold");